import { gql } from '@apollo/client';

export const PROPERTY_3DVIEWING_FRAGMENT = gql`
  fragment Property3DViewing on Property {
    viewing3d {
      info {
        url
      }
    }
  }
`;
